export default __webpack_public_path__ + "static/media/Dazzed-Light.fceb15ad.otf";